import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';
import { config } from '../../../Configurations';

export const LeftContainer = styled.div`
    background-image: ${props => `url(${config.baseUrl}/${props.background})`};
    height: 100vh;
    width: 30vw;
    background-size: cover;
    background-position: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;

    ${media.tablet`
        display: none;
    `};
`;

export const LeftContent = styled.div`
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000 94%);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const RightContainer = styled.div`
    width: 70vw;
    margin-left: 30vw;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${media.tablet`
        width: 100%;
        margin: 0;
    `};
`;

export const ColumnPageContainer = styled.div`
    width: 100%;
    display: none;

    ${media.tablet`
        display: flex;
        display: flex
        align-items: center;
        flex-direction: column;
    `};
`;

export const RowPageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;

    ${media.tablet`
            display: none;
        `};
`;

// planned workout row
export const PlansContainer = styled.div`
    width: 100%;
    margin-top: 45px;
    // display: flex;
    // flex-wrap: wrap;
`;

export const WorkoutCard = styled.div`
    width: 100%;
    display: flex;
    margin: 8px 0;
    padding: 8px 34px;
`;

export const WorkoutImage = styled.div`
    width: 60px;
    height: 60px;
    margin-right: 12px;
    background-image: ${props => (props.background ? `url(${config.baseUrl}/${props.background})` : null)};
    // background-size: cover;
    border-radius: 8px;
`;

export const EmptyWorkoutImage = styled.div`
    width: 60px;
    height: 60px;
    margin-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center
    border: 2px dashed #2b2b2c;
    border-radius: 8px;
`;

export const WorkoutBody = styled.div`
    flex: 1;
    padding: 4px 0;
`;

//TODO: add to layouts
export const TinyAvatar = styled.div`
    width: 16px;
    height: 16px;
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 100px;
    background-image: ${props => (props.image ? `url(${props.image})` : null)};
    background-size: cover;
`;

export const OuterMargin = styled.div`
    margin-right: ${props => (props.right ? props.right : null)};
    margin: ${props => (props.margin ? props.margin : null)};
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/PlannedWorkouts/style.js